// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-list__tile__action.no-min-width,.v-list__tile__avatar.no-min-width{min-width:0}.v-list-item__action:last-of-type:not(:only-child){margin-left:0}.employee-select-list{max-height:60vh;overflow-y:scroll}.gradient-overlay{background-image:linear-gradient(0deg,red,#00f);z-index:9999999999}", ""]);
// Exports
module.exports = exports;
